import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import SchoolIcon from "@mui/icons-material/School";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import AbcIcon from "@mui/icons-material/Abc";
import SubtitlesIcon from "@mui/icons-material/Subtitles";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import Fab from "@mui/material/Fab";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Box from "@mui/material/Box";
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import ForumIcon from '@mui/icons-material/Forum';
import SurroundSoundIcon from '@mui/icons-material/SurroundSound';

const enamadCode = `<img src="/img/pic/enamad.png" width="100" height="110"
onclick="window.open(&quot;https://trustseal.enamad.ir/?id=385160&Code=CTDn5KsaHUcqrnRPVKn59TLPggOwzwHE&quot;, &quot;Popup&quot;,&quot;toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30&quot;)"
alt="enamad">`

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.mode === "dark" ? "#003892" : "#001e3c",
    width: 32,
    height: 32,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2,
  },
}));

const drawerWidth = 240;
const openedMixin = (theme, closemenudrawer) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  transition: theme.transitions.create("height", {
    easing: theme.transitions.easing.sharp,
    duration: 1000,
  }),
  overflowY: closemenudrawer == "close" ? "hidden" : "auto",
  height:
    closemenudrawer == "close" ? `calc(${theme.spacing(6)} + 0px)` : "100%",
  [theme.breakpoints.up("sm")]: {
    height:
      closemenudrawer == "close" ? `calc(${theme.spacing(8)} + 0px)` : "100%",
  },
});

const closedMixin = (theme, closemenudrawer) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  transition: theme.transitions.create("height", {
    easing: theme.transitions.easing.sharp,
    duration: 1000,
  }),
  overflowX: "hidden",
  overflowY: closemenudrawer == "close" ? "hidden" : "auto",
  width: "0px",
  height:
    closemenudrawer == "close" ? `calc(${theme.spacing(6)} + 0px)` : "100%",
  [theme.breakpoints.up("sm")]: {
    width: "0px",
    height:
      closemenudrawer == "close" ? `calc(${theme.spacing(8)} + 0px)` : "100%",
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, closemenudrawer }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme, closemenudrawer),
    "& .MuiDrawer-paper": openedMixin(theme, closemenudrawer),
  }),
  ...(!open && {
    ...closedMixin(theme, closemenudrawer),
    "& .MuiDrawer-paper": closedMixin(theme, closemenudrawer),
  }),
}));

export default function AppbarSidebar(props) {
  const { mainPageNumber, handlePageNumber, children, controlThemeMode } =
    props;
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [closemenudrawer, setCloseMenuDrawer] = React.useState("close");

  const handleDrawerOpen = () => {
    setOpen(true);
    setCloseMenuDrawer("open")
  };

  const handleDrawerClose = () => {
    setOpen(false);
    setCloseMenuDrawer("close")
  };

  React.useEffect(() => {
    setCloseMenuDrawer("close")
    setOpen(false);
  }, [mainPageNumber]);

  return (
    <>
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 0,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
          {children}
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open} closemenudrawer={closemenudrawer}>
        <DrawerHeader>
          <MaterialUISwitch
            onClick={controlThemeMode}
            sx={{ m: 1 }}
            checked={!JSON.parse(localStorage.getItem("themeMode"))}
          />
          <Typography
            variant="subtitle"
            noWrap
            component="div"
            sx={{ mx: "auto", display: "contents" }}
          >
            <Typography sx={{ cursor: "pointer" }} onClick={(event) => handlePageNumber(event, 0)} >UMLANG.COM</Typography>
          </Typography>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {[
            "مشاهده فیلم",
            "پروفایل",
            "یادگیری پیشرفته",
            "لغات من",
            "معرفی به دوستان",
            // "آموزشگاه های زبان",
            "درآمد ها و حسابداری",
            "پشتبانی و درخواست ها",
            "لایتنر",
            "ارتباط با ما",
            "زیرنویس ها",
            "همکاری",
            "انجمن",
          ].map((text, index) => (
            <ListItem key={text} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                selected={mainPageNumber === index}
                onClick={(event) => {
                  if (index == 11) window.open("https://forum.umlang.com");
                  else handlePageNumber(event, index)
                }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {index === 0 ? <OndemandVideoIcon /> : null}
                  {index === 1 ? <AccountBoxIcon /> : null}
                  {index === 2 ? <LightbulbIcon /> : null}
                  {index === 3 ? <AbcIcon /> : null}
                  {index === 4 ? <Diversity3Icon /> : null}
                  {/* {index === 4 ? <SchoolIcon /> : null} */}
                  {index === 5 ? <LocalAtmIcon /> : null}
                  {index === 6 ? <SupportAgentIcon /> : null}
                  {index === 7 ? <ViewCarouselIcon /> : null}
                  {index === 8 ? <ContactPhoneIcon /> : null}
                  {index === 9 ? <SubtitlesIcon /> : null}
                  {index === 10 ? <SurroundSoundIcon /> : null}
                  {index === 11 ? <ForumIcon /> : null}
                </ListItemIcon>
                <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Box sx={{ alignSelf: "center", mt: 1, background: "white", borderRadius: "25%", marginTop: "auto" }} dangerouslySetInnerHTML={{ __html: enamadCode }} />
      </Drawer>
    </>
  );
}
